/**
 * WEB-3826 (доработка по весу первого экрана) — системная страница воронки
 * ленивым куском. Страница («не найдена», «недоступна», «сервис недоступен»,
 * «только автору») — не первый экран квиза: покупатель видит её вместо
 * воронки, а со статическим импортом её стили `styles/public-system.css` и
 * код ехали в каждый первый экран (замер 29.10: +2 548 сырых байт, из них CSS
 * 2 400). Места показа (`PublicHostRouter`, `PublicQuiz`, `PublicPaywall`)
 * зовут эту обёртку; кусок со стилями приезжает, только когда страница
 * показывается. Пока он едет — пусто (как и до ответа резолва).
 *
 * Статического ребра к `PublicSystemPage.tsx` из первого экрана нет — держит
 * `FIRST_SCREEN_DEFERRED_MODULES` (`build-guards/publicEntryGuard.ts`).
 *
 * `lazyWithRetry`, а не голый `lazy` (приёмка круг 3, класс шрама WEB-1539):
 * страница показывается как раз тогда, когда сеть сбоит, — кусок, который не
 * приехал, лечится однократной перезагрузкой за свежей сборкой, а не экраном
 * аварии кабинета. Ключ явный, как у остальных кусков публичного пути.
 */
import { Suspense, type ReactElement } from 'react';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import type { PublicSystemPageProps } from './PublicSystemPage';

const LazyPage = lazyWithRetry(
  () =>
    import('./PublicSystemPage').then((m) => ({ default: m.PublicSystemPage })),
  'page:public-system',
);

export function PublicSystemPageLazy(
  props: PublicSystemPageProps,
): ReactElement {
  return (
    <Suspense fallback={null}>
      <LazyPage {...props} />
    </Suspense>
  );
}
